import {
    getNumberValue,
    getStringValue,
    isRecord,
} from '@apps/web/components/phoebe_chat/record_utils';
import { type RecommendationBatchAggregateDecision } from '@apps/web/components/phoebe_chat/transcript_types';

export function parseRecommendationBatchAggregate(text: string | null): {
    readonly batchId: string;
    readonly decisionCount: number | null;
    readonly decisions: ReadonlyArray<RecommendationBatchAggregateDecision>;
} | null {
    if (!text || !text.trimStart().startsWith('{')) {
        return null;
    }
    let parsed: unknown;
    try {
        parsed = JSON.parse(text);
    } catch {
        return null;
    }
    if (!isRecord(parsed) || !Array.isArray(parsed['decisions'])) {
        return null;
    }
    const batchId = getStringValue(parsed, 'batch_id');
    if (!batchId) {
        return null;
    }
    const decisions = parsed['decisions'].flatMap((decision) => {
        if (!isRecord(decision)) {
            return [];
        }
        const status = getStringValue(decision, 'status');
        if (!status) {
            return [];
        }
        return [
            {
                caregiver_id: getStringValue(decision, 'caregiver_id'),
                status,
                ...(typeof decision['should_add'] === 'boolean'
                    ? { should_add: decision['should_add'] }
                    : {}),
                ...(typeof decision['reasoning'] === 'string'
                    ? { reasoning: decision['reasoning'] }
                    : {}),
                ...(typeof decision['suggestion'] === 'string'
                    ? { suggestion: decision['suggestion'] }
                    : {}),
                ...(typeof decision['error'] === 'string'
                    ? { error: decision['error'] }
                    : {}),
            },
        ];
    });
    return {
        batchId,
        decisionCount: getNumberValue(parsed, 'decision_count'),
        decisions,
    };
}
